import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import Youtube from "../../assets/img/icon/youtube.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { GetBussiness, UpdateBusiness } from "./myBusinessApi";

import AddLocationIcon from "@mui/icons-material/AddLocation";
import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
import { validationsSubmits } from "./myBusinessValidationFunctions";
import { FormGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import ApModal from "../../common/AppoinmetModalppBtn";
import MediaModel from "../../common/mediaModel";
import MediaModelApp from "../../common/mediaModelApp";
import MediaCardInput from "../../common/mediaCardInput";
import PersonIcon from "@mui/icons-material/Person";
import { cityNameCll } from "../landingPage/landingPageApi";
import ImageUploader from "../../common/imageUpload";
import { formDataFn } from "../../common/commonUtils/commonUtilFunction";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import MultipleImageInput from "../../common/imgUploadMul";
import Heading from "../../common/Heading";

export default function MyBusiness() {
  const [MyBusinessData, setMyBussinessData] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);

  const [hide, setHide] = useState(false);

  const userDetail = useSelector((state) => state.reducer.userDetail);
  const getData = async () => {
    await GetBussiness().then((res) => {
      console.log("es.data.data[0] ", res?.data?.data[0]);
      let obj = { ...res?.data?.data[0] };
      if (!res?.data?.data[0]) return;
      let arr = [];
      let item = res?.data?.data[0];
      if (item?.logoPath1 && item?.logoPath1 != "") {
        arr.push({ url: item?.logoPath1, file: item?.logoPath1 });
      }
      if (item?.logoPath2 && item?.logoPath2 != "") {
        arr.push({ url: item?.logoPath2, file: item?.logoPath2 });
      }
      if (item?.logoPath3 && item?.logoPath3) {
        arr.push({ url: item?.logoPath3, file: item?.logoPath3 });
      }
      if (item?.logoPath4 && item?.logoPath4) {
        arr.push({ url: item?.logoPath4, file: item?.logoPath4 });
      }
      console.log("formdata = arr ", arr);

      setSelectedImages([...arr]);

      setMyBussinessData({
        ...obj,
        //   mobileNumber: userDetail?.mobileNumber,
        //   File1:item?.logoPath1?item?.logoPath1:"",
        //   File2:item?.logoPath2?item?.logoPath2:"",
        //   File3:item?.logoPath3?item?.logoPath3:"",
        //   File4:item?.logoPath4?item?.logoPath4:"",
      });
    });
  };
  const [dropDown, setDropDown] = useState({
    buinessChategory: [
      "Salon",
      "Wellness center",
      "Unisex Parlour",
      "Mens Parlour",
      "Beauty Parlour",
      "Tatoo Art Studio",
      "Massage Center",
      "Mehndi Artist",
      "Skincare",
      "Panchkarm",
      "Makeup & Hairstyle Artist",
    ],
    serviceTo: ["Not set", "Male", "Female", "Unisex"],

    serviceFrom: ["Home service", "In shop", "Both"],
  });
  // function optionVal(data) {
  //   let dd = "";
  //   let dataColl = [
  //     "google",
  //     "website",
  //     "instagram",
  //     "facebook",
  //     "youTube",
  //     "pinterest",
  //     "twitter",
  //     "linkedIn",
  //   ];
  //   let obj = { ...MyBusinessData };
  //   dataColl.forEach((ele, index) => {
  //     if (obj[ele]) {
  //       dd += obj[ele] + ",";
  //     }
  //   });

  //   return dd;
  // }
  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  const submit = async () => {
    const pattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    const valid = validationsSubmits(MyBusinessData);
    if (valid.status) {
      let obj = {
        ...MyBusinessData,
        enterpriseName: MyBusinessData?.enterpriseName,
      };
      obj["File1"] = null;
      obj["File2"] = null;
      obj["File3"] = null;
      obj["File4"] = null;
      obj["logoPath1"] = null;
      obj["logoPath2"] = null;
      obj["logoPath3"] = null;
      obj["logoPath4"] = null;
      obj["logoPath5"] = null;
      selectedImages.forEach((ele, index) => {
        obj["File" + (index == 0 ? "" : index + 1)] = ele.file
          ? ele.file
          : ele.url;
      });
      let payload = formDataFn({ ...obj });
      console.log("payload ", payload);

      await UpdateBusiness(formDataFN(payload))
        .then((res) => {
          if (res?.data?.succeeded) {
            Swal.fire({
              title: "Update Successfully",
              icon: "success",

              ...swalAlertPopProps,
            });
          } else {
            Swal.fire({
              title: res?.data?.message,
              icon: "error",

              ...swalAlertPopProps,
            });
          }

          getData();
        })
        .catch((err) => {});
    } else {
      Swal.fire({
        text: valid.msg,
        icon: "warning",

        ...swalAlertPopProps,
      });
    }
  };
  useEffect(() => {}, []);
  useEffect(() => {
    if (userDetail?.mobileNumber) {
      if (userDetail.role === "Associate") return;
      getData();
      console.log("userDetail@@@@@@@@@@@@@@@@ ", userDetail);
    }
  }, [userDetail]);
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}
      {MyBusinessData && (
        <Grid item xs={12}>
          <Heading name="My Business" />

          {/* <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px 15px",
                mt: { sm: "10px", xs: "1px" },
                borderRadius: "5px",
                color: "#01008B", // optional text color
                textAlign: "left",
                marginBottom: "20px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "13px", sm: "14px", md: "20px" },
                }}
              >
                My Business
              </Typography>
            </Grid>
          </Grid> */}
          <Grid
            container
            spacing={2}
            sx={{
              margin: 0,
              padding: { xs: "0px", sm: "20px" },
              borderRadius: "10px",
              backgroundColor: "#fff",
              height: "100vh",
              overflow: "auto",
              pr: { xs: 1, sm: 4 },
            }}
          >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3}>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: { sm: "end", xs: "center" },
                    }}
                  >
                    {MyBusinessData?.logoPath &&
                    !MyBusinessData?.selectedImage ? (
                      <Box
                        component="img"
                        src={MyBusinessData.logoPath}
                        alt="Selected"
                        onClick={() =>
                          document.getElementById("imageUpload").click()
                        }
                        sx={{
                          width: { xs: "100px", sm: "150px", md: "200px" },
                          height: { xs: "100px", sm: "150px", md: "200px" },
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                      />
                    ) : MyBusinessData?.selectedImage ? (
                      <Box
                        src={MyBusinessData.selectedImage}
                        alt="Selected"
                        onClick={() =>
                          document.getElementById("imageUpload").click()
                        }
                        sx={{
                          width: { xs: "100px", sm: "150px", md: "200px" },
                          height: { xs: "100px", sm: "150px", md: "200px" },
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <Button
                        variant="outlined"
                        endIcon={<AddAPhotoOutlinedIcon />}
                        onClick={() =>
                          document.getElementById("imageUpload").click()
                        }
                      >
                        Attach Image
                      </Button>
                    )}
                    <input
                      type="file"
                      id="imageUpload"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          const file = e.target.files[0];
                          setMyBussinessData({
                            ...MyBusinessData,
                            File: file,
                            selectedImage: URL.createObjectURL(file),
                          });
                        }
                      }}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={9}
                  sx={{
                    display: "flex",
                    justifyContent: { sm: "start", xs: "center" },
                    alignItems: "center",
                  }}
                >
                  <div>
                    {/* Inline MediaCardInput component */}
                    <Box
                      sx={{
                        padding: "10px",
                        backgroundColor: "#EEEEFF",
                        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.25)",
                        borderRadius: "5px",
                        width: { xs: "250px", sm: "300px", md: "500px" },
                        margin: "10px 0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* <IconButton component="a" href={MyBusinessData?.profileId} target="_blank" aria-label="go to link">

                      </IconButton> */}
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          color="grey"
                          sx={{
                            margin: "0px !important",
                            padding: "0px !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            color: "#4E4E4E",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            fontWeight: 500,
                          }}
                        >
                          <PersonIcon
                            sx={{
                              color: "black",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                          />
                          Profile Id
                        </Typography>
                        <TextField
                          fullWidth
                          id="profileId"
                          label=""
                          variant="standard"
                          sx={{
                            margin: "0px !important",
                            padding: "15px 0 !important",
                            whiteSpace: "normal",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                          InputProps={{
                            sx: {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              // fontWeight: 500,
                            },
                          }}
                          value={MyBusinessData?.profileId}
                          onChange={(e) => {}}
                        />
                      </Box>
                      <IconButton
                        onClick={() => {
                          navigator.clipboard.writeText(
                            MyBusinessData?.profileId || "",
                          );
                          alert("Link copied to clipboard!");
                        }}
                        sx={{
                          fontSize: { xs: "14px", sm: "13px", md: "20px" },
                        }}
                        aria-label="copy link"
                      >
                        <ContentCopyIcon
                          sx={{
                            color: "#4E4E4E",
                            fontSize: { xs: "14px", sm: "13px", md: "20px" },
                          }}
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          if (navigator.share) {
                            navigator
                              .share({
                                title: "Share Link",
                                url: MyBusinessData?.profileId,
                              })
                              .catch((error) =>
                                console.error("Error sharing:", error),
                              );
                          } else {
                            alert(
                              "Share not supported on this browser. Link copied instead.",
                            );
                            navigator.clipboard.writeText(
                              MyBusinessData?.profileId || "",
                            );
                          }
                        }}
                        aria-label="share link"
                      >
                        <ShareIcon
                          sx={{
                            color: "#4E4E4E",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        />
                      </IconButton>
                    </Box>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                      sx={{
                        marginTop: "15px",
                        padding: "10px 40px",
                        height: "40px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Add Logo
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="enterpriseName"
                size="small"
                label="Enterprise Name"
                value={MyBusinessData?.enterpriseName}
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    enterpriseName: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel id="tags-label" className="mulish">
                  Business Category
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="tags-label"
                  id="businessCategory"
                  name="businessCategory"
                  value={MyBusinessData?.businessCategory}
                  onChange={(e) => {
                    setMyBussinessData({
                      ...MyBusinessData,
                      businessCategory: e.target.value,
                    });
                  }}
                  size="small"
                  input={<OutlinedInput label="BusinessCategory" />}
                  sx={{
                    height: "40px",
                  }}
                >
                  {dropDown?.buinessChategory?.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{ fontSize: "0.75rem", padding: "4px 8px" }}
                    >
                      <ListItemText
                        primary={name}
                        primaryTypographyProps={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontFamily: "Montserrat",
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="branchName"
                label="Branch Name"
                size="small"
                value={MyBusinessData?.branchName}
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    branchName: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                id="BrifeAddress"
                // label="Brief Address"
                label={
                  <span>
                    Brief Address <span style={{ color: "red" }}>*</span>
                  </span>
                }
                size="small"
                // value={MyBusinessData?.address}
                value={
                  MyBusinessData?.address == null ||
                  MyBusinessData?.address === "null"
                    ? ""
                    : MyBusinessData.address
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    address: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="state"
                size="small"
                label="State"
                value={
                  MyBusinessData?.state == null ||
                  MyBusinessData?.state === "null"
                    ? ""
                    : MyBusinessData.state
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    state: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="district"
                label="District"
                size="small"
                // value={MyBusinessData?.district}
                value={
                  MyBusinessData?.district == null ||
                  MyBusinessData?.district === "null"
                    ? ""
                    : MyBusinessData.district
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    district: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="city"
                size="small"
                label="City"
                // value={MyBusinessData?.city}
                value={
                  MyBusinessData?.city == null ||
                  MyBusinessData?.city === "null"
                    ? ""
                    : MyBusinessData.city
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    city: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="pincode"
                size="small"
                label="Pincode"
                // value={MyBusinessData?.pincode}
                value={
                  MyBusinessData?.pincode == null ||
                  MyBusinessData?.pincode === "null"
                    ? ""
                    : MyBusinessData.pincode
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    pincode: e.target.value,
                  });
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                id="area"
                size="small"
                // label="Area"
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                label={
                  <span>
                    Area <span style={{ color: "red" }}>*</span>
                  </span>
                }
                // value={MyBusinessData?.area}
                value={
                  MyBusinessData?.area == null ||
                  MyBusinessData?.area === "null"
                    ? ""
                    : MyBusinessData.area
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    area: e.target.value,
                  });
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="latitude"
                label="Latitude"
                size="small"
                // value={MyBusinessData?.latitude}
                value={
                  MyBusinessData?.latitude == null ||
                  MyBusinessData?.latitude === "null"
                    ? ""
                    : MyBusinessData.latitude
                }
                onChange={(e) => {
                  // setMyBussinessData({
                  //   ...MyBusinessData,
                  //   latitude: e.target.value,
                  // });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
                readOnly={true}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="longitude"
                label="Longitude"
                size="small"
                // value={MyBusinessData?.longitude}
                value={
                  MyBusinessData?.longitude == null ||
                  MyBusinessData?.longitude === "null"
                    ? ""
                    : MyBusinessData.longitude
                }
                onChange={(e) => {
                  // setMyBussinessData({
                  //   ...MyBusinessData,
                  //   longitude: e.target.value,
                  // });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
                readOnly={true}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                sx={{
                  height: "40px",
                  width: { sm: "50%", xs: "100%" },
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },

                  display: "flex",
                  justifyContent: "space-between",
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
                onClick={() => {
                  cityNameCll((data) => {
                    console.log("location", data);
                    setMyBussinessData((prev) => {
                      let temp = { ...prev };
                      temp.longitude = data?.lon;
                      temp.latitude = data?.lat;
                      console.log("temp", temp);
                      return {
                        ...temp,
                        mobileNumber: userDetail?.mobileNumber,
                      };
                    });
                    // asignCityName(data?.city)
                    // setCurrentLocation(data?.city)
                    // dispatch(setNavBarInputFields({location:data?.city}))
                  });
                }}
                variant="contained"
                endIcon={<AddLocationIcon />}
              >
                Set Location
              </Button>
            </Grid>
            <Grid item md={3} xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="tags-label" className="mulish">
                  Service To
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="tags-label"
                  id="businessCategory"
                  //   multiple
                  name="businessCategory"
                  // value={MyBusinessData?.serviceTo}
                  value={
                    MyBusinessData?.serviceTo == null ||
                    MyBusinessData?.serviceTo === "null"
                      ? ""
                      : MyBusinessData.serviceTo
                  }
                  onChange={(e) => {
                    setMyBussinessData({
                      ...MyBusinessData,
                      serviceTo: e.target.value,
                    });
                  }}
                  input={<OutlinedInput label="ServicesTo" />}
                  sx={{
                    height: "40px",
                  }}
                  //   renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {dropDown?.serviceTo?.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{ fontSize: "0.75rem", padding: "4px 8px" }}
                    >
                      {/* <Checkbox checked={formData.tags.indexOf(name) > -1} /> */}
                      <ListItemText
                        primary={name}
                        primaryTypographyProps={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontFamily: "Montserrat",
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={3} xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="tags-label" className="mulish">
                  Service From
                </InputLabel>
                <Select
                  labelId="tags-label"
                  id="businessCategory"
                  //   multiple
                  name="businessCategory"
                  value={MyBusinessData?.serviceFrom}
                  onChange={(e) => {
                    setMyBussinessData({
                      ...MyBusinessData,
                      serviceFrom: e.target.value,
                    });
                  }}
                  InputLabelProps={{
                    sx: {
                      // color: "#545454",
                      // fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      // paddingX: "7px",
                    },
                  }}
                  input={<OutlinedInput label="ServiceFrom" />}
                  sx={{
                    height: "40px",
                  }}
                  //   renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {dropDown?.serviceFrom?.map((name) => (
                    <MenuItem key={name} value={name}>
                      {/* <Checkbox checked={formData.tags.indexOf(name) > -1} /> */}
                      <ListItemText
                        primary={name}
                        primaryTypographyProps={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontFamily: "Montserrat",
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="openingTime"
                label="Opening Time"
                size="small"
                value={MyBusinessData?.openingTime}
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    openingTime: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="closingTime"
                label="Closing Time"
                size="small"
                value={MyBusinessData?.closingTime}
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    closingTime: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="mobileno"
                // label="Mobile Number"
                label={
                  <span>
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </span>
                }
                size="small"
                InputProps={{
                  readOnly: true,
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                // value={userDetail?.mobileNumber}
                value={
                  MyBusinessData?.mobileNumber == null ||
                  MyBusinessData?.mobileNumber === "null"
                    ? ""
                    : MyBusinessData.mobileNumber
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="mobileno"
                label="Alternate Mobile Number"
                size="small"
                // value={MyBusinessData?.mobileNumber2}
                value={
                  MyBusinessData?.mobileNumber2 == null ||
                  MyBusinessData?.mobileNumber2 === "null"
                    ? ""
                    : MyBusinessData.mobileNumber2
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    setMyBussinessData({
                      ...MyBusinessData,
                      mobileNumber2: value,
                    });
                  }
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="mailID1"
                size="small"
                label="Email Id"
                // value={MyBusinessData?.mailID1}
                value={
                  MyBusinessData?.mailID1 == null ||
                  MyBusinessData?.mailID1 === "null"
                    ? ""
                    : MyBusinessData.mailID1
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    mailID1: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="mailID2"
                label="Email Id"
                size="small"
                // value={MyBusinessData?.mailID2}
                value={
                  MyBusinessData?.mailID2 == null ||
                  MyBusinessData?.mailID2 === "null"
                    ? ""
                    : MyBusinessData.mailID2
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    mailID2: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="upiid"
                label="UPI ID"
                size="small"
                // value={MyBusinessData?.upiid}
                value={
                  MyBusinessData?.upiid == null ||
                  MyBusinessData?.upiid === "null"
                    ? ""
                    : MyBusinessData.upiid
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    upiid: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="BandACNumber"
                label="Bank A/C Number"
                size="small"
                readOnly
                // value={MyBusinessData?.accountNumber}
                value={
                  MyBusinessData?.accountNumber == null ||
                  MyBusinessData?.accountNumber === "null"
                    ? ""
                    : MyBusinessData.accountNumber
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    accountNumber: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="IFSCCODE"
                size="small"
                label="IFSC code of the branch"
                // value={MyBusinessData?.ifsc}
                value={
                  MyBusinessData?.ifsc == null ||
                  MyBusinessData?.ifsc === "null"
                    ? ""
                    : MyBusinessData.ifsc
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    ifsc: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="GSTREGISTRATIONNUMBER"
                size="small"
                label="GST registration number"
                // value={MyBusinessData?.gstRegistrationNumber || ""}
                value={
                  MyBusinessData?.gstRegistrationNumber == null ||
                  MyBusinessData?.gstRegistrationNumber === "null"
                    ? ""
                    : MyBusinessData.gstRegistrationNumber
                }
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  if (value.length <= 15) {
                    setMyBussinessData((prev) => ({
                      ...prev,
                      gstRegistrationNumber: value,
                    }));
                  }
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                id="referenceId"
                label="Reference Id"
                size="small"
                // value={MyBusinessData?.referenceId}
                value={
                  MyBusinessData?.referenceId == null ||
                  MyBusinessData?.referenceId === "null"
                    ? ""
                    : MyBusinessData.referenceId
                }
                onChange={(e) => {
                  setMyBussinessData({
                    ...MyBusinessData,
                    referenceId: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormGroup>
                <FormControlLabel
                  sx={{
                    justifyContent: "space-between",
                    m: 0,
                    flexDirection: "row-reverse",
                  }}
                  control={
                    <Switch
                      checked={MyBusinessData?.isPrintQRCodeOnBill}
                      onChange={(e) => {
                        // onChange("isActive", e.target.checked);
                        setMyBussinessData({
                          ...MyBusinessData,
                          isPrintQRCodeOnBill: e.target.checked,
                        });
                      }}
                    />
                  }
                  InputLabelProps={{
                    sx: {
                      // color: "#545454",
                      // fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      // paddingX: "7px",
                    },
                  }}
                  label="Do you want to print QR code on bill"
                />
              </FormGroup>
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl
                fullWidth
                margin="normal"
                size="small"
                onClick={() => {
                  setHide(true);
                }}
              >
                <InputLabel id="tags-label" className="mulish">
                  Media Link
                </InputLabel>
                <Select
                  labelId="tags-label"
                  id="businessCategory"
                  readOnly={true}
                  //   multiple
                  name="businessCategory"
                  value={optionVal(MyBusinessData)}
                  onChange={(e) => {
                    setMyBussinessData({
                      ...MyBusinessData,
                      serviceTo: e.target.value,
                    });
                  }}
                  InputLabelProps={{
                    sx: {
                      // color: "#545454",
                      // fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      // paddingX: "7px",
                    },
                  }}
                  input={<OutlinedInput label="Services" />}
                  //   renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  <MenuItem value={optionVal(MyBusinessData)}>
                    <ListItemText
                      primary={optionVal(MyBusinessData)}
                      primaryTypographyProps={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontFamily: "Montserrat",
                      }}
                    />
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <MultipleImageInput
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{ mt: 3, mb: 2 }}
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
      {/* <ApModal open={} setOpen={} /> */}
      {MyBusinessData != null && (
        <MediaModelApp
          open={hide}
          setOpen={setHide}
          modelData={{
            google: "",
            website: "",
            instagram: "",
            facebook: "",
            youTube: "",
            pinterest: "",
            twitter: "",
            linkedIn: "",
            ...MyBusinessData,
          }}
          setModalData={setMyBussinessData}
        />
      )}
    </Grid>
  );
}
